import type { SeoLang } from '../site';

/** Words of the SEO sections drawn by the app (and written by the build). */
export const SEO_UI: Record<
  SeoLang,
  {
    home: string;
    guides: string;
    allGuides: string;
    readGuide: string;
    faq: string;
    toursOfGuide: string;
    relatedGuides: string;
    planTrip: string;
    updated: string;
    toursInParaty: string;
    perPerson: string;
    perBoat: string;
    from: string;
    menu: string;
    languages: string;
    contact: string;
    askWhatsApp: string;
    /** Message the WhatsApp button opens with; {guide} is the guide's name. */
    whatsappText: string;
  }
> = {
  pt: {
    home: 'Início',
    guides: 'Guias de Paraty',
    allGuides: 'Ver todos os guias',
    readGuide: 'Ler o guia',
    faq: 'Perguntas frequentes',
    toursOfGuide: 'Passeios para reservar',
    relatedGuides: 'Mais guias de Paraty',
    planTrip: 'Planeje o seu passeio',
    updated: 'Atualizado em',
    toursInParaty: 'Passeios em Paraty',
    perPerson: 'por pessoa',
    perBoat: 'pelo passeio completo',
    from: 'a partir de',
    menu: 'Menu principal',
    languages: 'Idiomas',
    contact: 'Contato',
    askWhatsApp: 'Tirar dúvidas no WhatsApp',
    whatsappText: 'Olá! Li o guia "{guide}" no site da AQUAMARINA TOURS e quero ajuda para escolher meu passeio.',
  },
  es: {
    home: 'Inicio',
    guides: 'Guías de Paraty',
    allGuides: 'Ver todas las guías',
    readGuide: 'Leer la guía',
    faq: 'Preguntas frecuentes',
    toursOfGuide: 'Paseos para reservar',
    relatedGuides: 'Más guías de Paraty',
    planTrip: 'Planea tu paseo',
    updated: 'Actualizado el',
    toursInParaty: 'Paseos en Paraty',
    perPerson: 'por persona',
    perBoat: 'por el paseo completo',
    from: 'desde',
    menu: 'Menú principal',
    languages: 'Idiomas',
    contact: 'Contacto',
    askWhatsApp: 'Consultar por WhatsApp',
    whatsappText: '¡Hola! Leí la guía "{guide}" en el sitio de AQUAMARINA TOURS y quiero ayuda para elegir mi paseo.',
  },
  en: {
    home: 'Home',
    guides: 'Paraty travel guides',
    allGuides: 'See all guides',
    readGuide: 'Read the guide',
    faq: 'Frequently asked questions',
    toursOfGuide: 'Tours to book',
    relatedGuides: 'More Paraty guides',
    planTrip: 'Plan your tour',
    updated: 'Updated on',
    toursInParaty: 'Tours in Paraty',
    perPerson: 'per person',
    perBoat: 'for the whole tour',
    from: 'from',
    menu: 'Main menu',
    languages: 'Languages',
    contact: 'Contact',
    askWhatsApp: 'Ask us on WhatsApp',
    whatsappText: 'Hi! I read the "{guide}" guide on the AQUAMARINA TOURS website and would like help choosing my tour.',
  },
  fr: {
    home: 'Accueil',
    guides: 'Guides de Paraty',
    allGuides: 'Voir tous les guides',
    readGuide: 'Lire le guide',
    faq: 'Questions fréquentes',
    toursOfGuide: 'Excursions à réserver',
    relatedGuides: 'Autres guides de Paraty',
    planTrip: 'Préparez votre excursion',
    updated: 'Mis à jour le',
    toursInParaty: 'Excursions à Paraty',
    perPerson: 'par personne',
    perBoat: 'pour l’excursion complète',
    from: 'dès',
    menu: 'Menu principal',
    languages: 'Langues',
    contact: 'Contact',
    askWhatsApp: 'Nous écrire sur WhatsApp',
    whatsappText: 'Bonjour ! J’ai lu le guide « {guide} » sur le site d’AQUAMARINA TOURS et j’aimerais de l’aide pour choisir mon excursion.',
  },
};

/** "23 de outubro de 2026" in the page's language. */
export function formatDate(iso: string, lang: SeoLang): string {
  const locale = { pt: 'pt-BR', es: 'es', en: 'en-US', fr: 'fr-FR' }[lang];
  return new Date(`${iso}T12:00:00Z`).toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
}
